import { OAuthTokenStorage } from '@norlys-a-s/norlys-play-kmm';
import { storePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';

/**
 * Extends KMM class OAuthTokenStorage to handle persistent storage of tokens (by the partition/profile swap bug that exists on tizen tvs resulting in missing localStorage in rapid exit and open of app (inconsistent timing problem)).
 * This wrapper class ensures synchronization of tokens between localStorage and IndexedDB.
 *
 * one edge edge case that is not handled is the window of refreshing the token where we store the new token in localstorage as pending_tokens before saving them as access_token and refresh_token. If the app is closed before the pending_tokens are saved to access_token and refresh_token, the app will not have the new tokens in IndexedDB on next start.
 * this would log out the user in the case where they exit the app in the window of a second (every 6 hours) and they get the partion bug by opening the app within second of closing
 * - ASO
 */
export class ExtendedOAuthTokenStorage extends OAuthTokenStorage {
  /**
   * @param accessToken The access token to save
   * @param refreshToken The refresh token to save
   */
  override saveTokens(accessToken: string, refreshToken: string): void {
    storePersistentData('access_token', accessToken);
    storePersistentData('refresh_token', refreshToken);

    // Call the parent class implementation
    super.saveTokens(accessToken, refreshToken);
  }
}
